
































import { Component, Prop, Ref, Vue } from 'vue-property-decorator';
import ProductNew from '@/components/Product/ProductNew.vue';
import SPopup from '@/components/UI/Popup/SPopup.vue';

@Component({
  components: {
    ProductNew,
  },
})
export default class ProductNewButton extends Vue {
  @Prop(Boolean) private dimmer?: boolean;
  public showDialog = false;
  @Ref() public parentPopup?: SPopup
}
